import type { DoctorCaseImage } from 'www/vue_components/common/DoctorCases/types'

export const PERIOD_CASES: Record<Exclude<DoctorCaseImage['period'], ''>, string[]> = {
  at_once: ['сразу после процедуры', 'сразу после процедуры'],
  session: ['сеанс', 'сеанса', 'сеансов'],
  day: ['день', 'дня', 'дней'],
  week: ['неделю', 'недели', 'недель'],
  month: ['месяц', 'месяца', 'месяцев'],
  year: ['год', 'года', 'лет'],
}

export const DIALOG_PROPS = {
  default: {
    title: 'Что-то пошло не так',
    contentText: 'Попробуйте немного подождать и обновите страницу',
    confirmText: 'Обновить',
  },
  disconnect: {
    title: 'Нет соединения с интернетом',
    contentText: 'Проверьте соединение и попробуйте снова',
    confirmText: 'Понятно',
  },
}
